export default __webpack_public_path__ + "static/media/arrow-r.d8665570.svg";